// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-project-iteration-lookup-request-schema',
  type: 'object',
  required: ['projectId'],
  properties: {
    projectId: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
